import { convertToPixelCrop, Crop, cropToCanvas } from 'react-image-crop'

import { InputImageProps } from '#/components/FormCall/Inputs/InputImage/types'

export type CropToFileParams = {
  crop: Crop
  file: File
  image: HTMLImageElement
  output?: InputImageProps['output']
  picked: boolean
}

type Resolution = { height: number; width: number }
type FillBackgroundCanvas = {
  ctx: CanvasRenderingContext2D
  canvas: HTMLCanvasElement
}

const IMAGE_EXTENSION = /\.(avif|bmp|gif|jpe?g|png|svg|tiff?|webp)$/i

// backend não envia nome nos arquivos de imagem
const buildFileName = (name: string, type: string) => {
  const [, extension] = type.split('/')

  if (!extension || IMAGE_EXTENSION.test(name)) return name

  return `${name}.${extension}`
}

const fillBackgroundCanvas = ({ canvas, ctx }: FillBackgroundCanvas) => {
  ctx.fillStyle = '#fff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
}

const resizeCanvas = (original: HTMLCanvasElement, { height, width }: Resolution) => {
  const canvas = document.createElement('canvas')

  canvas.width = width
  canvas.height = height

  const ctx = canvas.getContext('2d')

  if (!ctx) return original

  fillBackgroundCanvas({ canvas, ctx })

  // suavizar imagem quando redimensionada
  ctx.imageSmoothingEnabled = true
  // algoritmo de suavização (melhor qualidade)
  ctx.imageSmoothingQuality = 'high'

  // resize
  ctx.drawImage(original, 0, 0, original.width, original.height, 0, 0, width, height)

  return canvas
}

export const cropToFile = async ({ crop, file, image, output, picked }: CropToFileParams) => {
  if (!crop.height || !crop.width) return

  const pixelCrop = convertToPixelCrop(crop, image.width, image.height)

  let canvas = document.createElement('canvas')

  const ctx = canvas.getContext('2d')

  if (!ctx) return

  fillBackgroundCanvas({ canvas, ctx })

  await cropToCanvas(image, canvas, pixelCrop)

  if (output?.resolution) {
    canvas = resizeCanvas(canvas, output.resolution)
  }

  const extension = output?.format ?? file.type
  const quality = picked ? output?.quality : undefined

  const blob = await new Promise<Blob | null>(resolve => {
    canvas.toBlob(resolve, extension, quality)
  })

  if (!blob) return
  const type = blob.type

  return new File([blob], buildFileName(file.name, type), { type })
}
